import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import ColorPicker from '../../../../shared/ui-builder/color-picker/Color-Picker';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import { CAROUSEL_LARGE_IMG_W_BG } from '../../../../constants/UiBuilderConst';
import HotelModuleSelector from '../../../../shared/ui-builder/hotel-module-selector/Hotel-Module-Selector';
import ModuleIdSelector from '../../../../shared/ui-builder/module-id-selector/Module-Id-Selector';
import { Add } from '@material-ui/icons';
import ViewAllSelector from '../../../../shared/ui-builder/view-all-selector/View-All-Selector';
import DraggableTabsList from '../../../../shared/draggable-tabs-list/Draggable-Tabs-List';
import MediaSelector from '../../../../shared/ui-builder/media-selector/Media-Selector';

//6 Large Image w/carousal
const LargeImageCarouselWithBackground = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;
  const initialSlide = [
    {
      id: `slide_1`,
      label: `Slide 1`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_2`,
      label: `Slide 2`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_3`,
      label: `Slide 3`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_4`,
      label: `Slide 4`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
  ];
  const addNewSlide = {
    id: '',
    label: '',
    imgURL: null,
    titleH3: '',
    redirectLink: {
      connection: '',
      linkId: '',
      isActive: false,
    },
    shadowOverlay: false,
    loopPlayBack: false,
    isVideo: false,
    videoURL: null,
  };
  const outerInit = {
    titleH2: '',
    imgURL: '',
    backgroundColor: config?.imgMain?.backgroundColor
      ? config?.imgMain?.backgroundColor
      : '#8f8f8f',
    redirectLink: {
      isActive: false,
      connection: '',
      linkId: '',
    },
    shadowOverlay: false,
    loopPlayBack: false,
    isVideo: false,
    videoURL: null,
  };
  const [slidesList, setSlidesList] = useState(
    config.slides && config.slides.length
      ? config.slides.map((e, index) => {
          return {
            ...e,
            id: `slide_${index + 1}`,
            label: `Slide ${index + 1}`,
          };
        })
      : initialSlide,
  );
  const [hotelModule, setHotelModule] = useState(config?.hotelModule || '');
  const [outerData, setOuterData] = useState(config.imgMain ? config.imgMain : outerInit);
  const [activeTabIndex, setActveTabIndex] = useState(0);
  const [activeTabContent, setActveTabContent] = useState(slidesList[0]);
  const [viewAll, setViewAll] = useState(
    config?.viewAll ? config.viewAll : { isActive: true, linkId: '' },
  );
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [error, setError] = useState(null);
  const [hotelModuleName, setHotelModulename] = useState(config?.imgMain?.titleH2 || '');
  const [hotelSubModuleName, setHotelSubModuleName] = useState([]);
  const [isSwapEnabled, setIsSwapEnabled] = useState(false);

  const maxSlidesCount = 20;

  useEffect(() => {
    if (config.slides && config.slides.length) {
      const setHotelModule = config.slides.map((currSliderValue, ndx) => {
        return { index: ndx, name: currSliderValue.titleH3 };
      });
      setHotelSubModuleName(setHotelModule);
    }
  }, []);

  useEffect(() => {
    const currSlider = slidesList?.map((sliderValue, ndx) => {
      if (sliderValue.hotelModuleId && !sliderValue.titleH3) {
        const subModule = hotelSubModuleName.find((val) => val.index === ndx);
        return { ...sliderValue, titleH3: subModule?.name };
      }
      return { ...sliderValue };
    });
    const currOuterConfig = { ...outerData };
    currOuterConfig.titleH2 = currOuterConfig.titleH2 || hotelModuleName;
    onItemChange({
      componentName: CAROUSEL_LARGE_IMG_W_BG,
      config: {
        hotelModule: hotelModule,
        imgMain: { ...currOuterConfig },
        slides: currSlider.map(({ id, label, ...keepAttrs }) => keepAttrs),
        viewAll: viewAll,
      },
    });
  }, [slidesList, outerData, hotelModule, viewAll, isSwapEnabled]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      setIsSwapEnabled(false);
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === CAROUSEL_LARGE_IMG_W_BG,
      );
      if (currError && currError.slides.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.slides.map((o) => o.pos),
        );
        setActveTabIndex(sliderNdx);
        setActveTabContent(slidesList[sliderNdx]);
      }
      setError(currError ?? null);
    }
  }, [handleError]);

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    }
    if (val?.type) return '';
    return 'required';
  };

  const handleTabData = (val, slideContent, field, type, moduleName) => {
    const thisErr = setErrorField(field, val);
    const newConfigErr = { ...error?.config };
    if (type === 'outerData') {
      newConfigErr[field] = thisErr;
    }
    const newSlidesErr = slidesList?.map((_, idx) => {
      const prev = error?.slides?.find((e) => e?.pos === idx) || { pos: idx };
      if (type !== 'outerData' && idx === activeTabIndex) {
        return { ...prev, [field]: thisErr };
      }
      return prev;
    });
    setError({ config: newConfigErr, slides: newSlidesErr });
    if (type === 'outerData') {
      const currOuterData = { ...outerData };
      switch (field) {
        case 'titleH2':
          currOuterData.titleH2 = val;
          break;
        case 'imgURL':
          currOuterData.imgURL = val;
          break;
        case 'backgroundColor':
          currOuterData.backgroundColor = val;
          break;
        case 'redirect':
          currOuterData.redirectLink.connection = val.type;
          currOuterData.redirectLink.linkId = val.value;
          break;
        case 'isActive':
          currOuterData.redirectLink.isActive = val;
          break;
        case 'viewAll':
          setViewAll({
            ...viewAll,
            linkId: val,
          });
          break;
        case 'viewAllStatus':
          setViewAll({
            ...viewAll,
            isActive: val,
          });
          break;
        case 'isVideo':
          currOuterData.isVideo = val;
          break;
        case 'shadowOverlay':
          currOuterData.shadowOverlay = val;
          break;
        case 'videoURL':
          currOuterData.videoURL = val;
          break;
        case 'loopPlayBack':
          currOuterData.loopPlayBack = val;
          break;
        default:
          break;
      }
      setOuterData(currOuterData);
    } else {
      switch (field) {
        case 'titleH3':
          slideContent.titleH3 = val;
          break;
        case 'imgURL':
          slideContent.imgURL = val;
          break;
        case 'redirect':
          slideContent.redirectLink.connection = val.type;
          slideContent.redirectLink.linkId = val.value;
          break;
        case 'isActive':
          slideContent.redirectLink.isActive = val;
          break;
        case 'isVideo':
          slideContent.isVideo = val;
          break;
        case 'shadowOverlay':
          slideContent.shadowOverlay = val;
          break;
        case 'videoURL':
          slideContent.videoURL = val;
          break;
        case 'loopPlayBack':
          slideContent.loopPlayBack = val;
          break;
        case 'hotelModuleId':
          slideContent.hotelModuleId = val ? val : '';
          slideContent.titleH3 = moduleName ? moduleName : '';
          const currentsubModuleName = [...hotelSubModuleName];
          const checkExistingModuleNdx = currentsubModuleName.findIndex(
            (moduleValue) => moduleValue.index === activeTabIndex,
          );
          if (checkExistingModuleNdx > -1) {
            currentsubModuleName[checkExistingModuleNdx].name = moduleName;
          } else {
            currentsubModuleName.push({
              index: activeTabIndex,
              name: moduleName,
            });
          }
          setHotelSubModuleName(currentsubModuleName);
          break;
        default:
          break;
      }
      setSlidesList(
        slidesList.map((slide, index) => {
          if (index === activeTabIndex) {
            return slideContent;
          } else {
            return slide;
          }
        }),
      );
    }
  };

  const onTabChange = (e, value) => {
    setActveTabIndex(value);
    setActveTabContent(slidesList[value]);
  };

  const hasError = (key, isReturnString = false) => {
    const hasSliderError = error?.slides?.find(
      (errorSlider) =>
        errorSlider.pos === activeTabIndex &&
        (errorSlider[key] === 'required' || errorSlider[key] === 'validUrl' || errorSlider[key] === 'safeDomain'),
    );
    if (key === 'imgURL' && error?.config[key] === 'required') {
      return true;
    } else if (key === 'videoURL' && error?.config[key] === 'required') {
      return true;
    } else if (key === 'videoURL' && (error?.config[key] === 'validUrl' || error?.config[key] === 'safeDomain')) {
      return error?.config[key];
    }
    if (isReturnString && hasSliderError) return hasSliderError?.videoURL;
    if (hasSliderError) return true;
    return false;
  };

  const onChangeHotelModule = (val, moduleName) => {
    setHotelModule(val || '');
    handleTabData(moduleName || '', null, 'titleH2', 'outerData');
    setHotelModulename(moduleName || '');
    setHotelSubModuleName([]);
    const tempSlidesList = slidesList.map((slide) => {
      return { ...slide, hotelModuleId: '', titleH3: '' };
    });
    setSlidesList(tempSlidesList);
    setActveTabContent(tempSlidesList[activeTabIndex]);
  };

  const AddNewSlide = (e) => {
    if (slidesList.length < maxSlidesCount) {
      const tempSlidesList = [...slidesList];
      addNewSlide.id = `slide_${slidesList.length + 1}`;
      addNewSlide.label = `Slide ${slidesList.length + 1}`;
      tempSlidesList.push(addNewSlide);
      setSlidesList(tempSlidesList);
      setActveTabIndex(tempSlidesList.length - 1);
      setActveTabContent(tempSlidesList[tempSlidesList.length - 1]);
    }
  };

  const removeSlide = (e) => {
    if (slidesList.length > 1) {
      const tempSlidesList = [...slidesList];
      tempSlidesList.splice(activeTabIndex, 1);
      setSlidesList(tempSlidesList);
      if (activeTabIndex === tempSlidesList.length) {
        setActveTabIndex(tempSlidesList.length - 1);
        setActveTabContent(tempSlidesList[tempSlidesList.length - 1]);
      } else {
        setActveTabContent(tempSlidesList[activeTabIndex]);
      }
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const newTabs = slidesList;
    const draggedTab = newTabs.splice(result.source.index, 1)[0];
    newTabs.splice(result.destination.index, 0, draggedTab);
    setActveTabIndex(result.destination.index);
    setActveTabContent(draggedTab);
    setSlidesList(newTabs);
    setIsSwapEnabled(true);
    const currSlider = slidesList?.map((sliderValue, ndx) => {
      if (sliderValue.hotelModuleId && !sliderValue.titleH3) {
        const subModule = hotelSubModuleName.find((val) => val.index === ndx);
        return { ...sliderValue, titleH3: subModule?.name };
      }
      return { ...sliderValue };
    });
    const currOuterConfig = { ...outerData };
    currOuterConfig.titleH2 = currOuterConfig.titleH2 || hotelModuleName;
    onItemChange({
      componentName: CAROUSEL_LARGE_IMG_W_BG,
      config: {
        hotelModule: hotelModule,
        imgMain: { ...currOuterConfig },
        slides: currSlider.map(({ id, label, ...keepAttrs }) => keepAttrs),
        viewAll: viewAll,
      },
    });
  };

  return (
    <>
      <div className='row my-2 mx-1'>
        <div className='col-md-10'>
          <div className='col-md-12 mb-3'>
            <HotelModuleSelector
              hotelModule={hotelModule}
              onChangeHotelModule={(e, moduleName) => onChangeHotelModule(e, moduleName)}
            />
          </div>
          <CustomUiBuilderTextField
            label='H2 Title'
            required={!Boolean(hotelModule)}
            className='col-md-12'
            value={outerData.titleH2}
            onChangeInput={(e) => handleTabData(e.target.value, null, 'titleH2', 'outerData')}
            maxLength={100}
            isAdornment={true}
            endAdornment={true}
            error={
              !isSwapEnabled && !hotelModule && error?.config?.titleH2 === 'required' ? true : false
            }
          />
          <div className='mb-4 mt-4'>
            <MediaSelector
              groupId={groupId}
              titleH2={'Image'}
              height={450}
              width={676}
              matrix={'px'}
              handleTabData={handleTabData}
              activeTabContent={outerData}
              isSwapEnabled={isSwapEnabled}
              hasError={hasError}
              ratio={'3:2'}
              title='Large Image'
              setIsSwapEnabled={setIsSwapEnabled}
              isCustom={true}
            />
          </div>
          <div className='col-md-12 background-color-titleH2 mb-2'>Background Color</div>
          <div
            className='color-preview d-flex justify-content-center align-items-center shadow mb-1'
            style={{
              backgroundColor: outerData.backgroundColor,
              cursor: 'pointer',
            }}
            onClick={() => setShowColorPicker(!showColorPicker)}
          >
            <span className='color-preview-label'>{outerData.backgroundColor}</span>
          </div>
          <RedirectSelector
            onValueChange={(e) => handleTabData(e, null, 'redirect', 'outerData')}
            redirectType={outerData.redirectLink.connection}
            value={outerData.redirectLink.linkId}
            onRedirectChange={(e) => {
              handleTabData(e, null, 'isActive', 'outerData');
            }}
            isActive={outerData.redirectLink.isActive}
            error={!isSwapEnabled && error?.config?.redirect === 'required' ? true : false}
          />
          <div className='row mt-4 mb-3'>
            <div className='col-md-12 slide-tabs d-flex horizontal-scroll-styled pb-2'>
              <DraggableTabsList
                onDragEnd={onDragEnd}
                tabs={slidesList}
                onTabChange={onTabChange}
                activeTabIndex={activeTabIndex}
              />
              <div className='ms-2'>
                <Button
                  disabled={slidesList.length >= maxSlidesCount}
                  variant='outlined'
                  size='medium'
                  color='secondary'
                  onClick={(e) => AddNewSlide(e)}
                >
                  <Add />
                </Button>
              </div>
            </div>
            <div className='col-md-12 mt-3'>
              <div className='d-flex justify-content-between px-3 py-2 remove-slide-div'>
                <div>Slide {activeTabContent?.id?.split('_')[1]}</div>
                <div className='text-underlined pointer' onClick={(e) => removeSlide(e)}>
                  Remove
                </div>
              </div>
              {hotelModule && (
                <div className='col-md-12'>
                  <ModuleIdSelector
                    key={activeTabContent?.id}
                    hotelModule={hotelModule}
                    hotelModuleId={activeTabContent.hotelModuleId}
                    onChangeHotelModuleId={(e, moduleName) =>
                      handleTabData(
                        e.target.value,
                        activeTabContent,
                        'hotelModuleId',
                        'slider',
                        moduleName,
                      )
                    }
                  />
                </div>
              )}
              <div className='col-md-12'>
                <CustomUiBuilderTextField
                  label='H3 Title'
                  required={!Boolean(activeTabContent.hotelModuleId)}
                  className='col-md-12 mt-3'
                  value={activeTabContent.titleH3}
                  onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'titleH3')}
                  maxLength={100}
                  isAdornment={true}
                  endAdornment={true}
                  error={
                    activeTabContent.hotelModuleId ? false : !isSwapEnabled && hasError('titleH3')
                  }
                />
                <div className='col-md-12 mt-4'>
                  <MediaSelector
                    groupId={groupId}
                    titleH2={'Image'}
                    height={220}
                    width={330}
                    matrix={'px'}
                    handleTabData={handleTabData}
                    activeTabContent={activeTabContent}
                    isSwapEnabled={isSwapEnabled}
                    hasError={hasError}
                    ratio={'3:2'}
                    setIsSwapEnabled={setIsSwapEnabled}
                  />
                </div>
                <div className='col-md-12 mt-4'>
                  <RedirectSelector
                    onValueChange={(e) => handleTabData(e, activeTabContent, 'redirect')}
                    redirectType={activeTabContent.redirectLink.connection}
                    value={activeTabContent.redirectLink.linkId}
                    onRedirectChange={(e) => {
                      handleTabData(e, activeTabContent, 'isActive');
                    }}
                    isActive={activeTabContent.redirectLink.isActive}
                    error={!isSwapEnabled && hasError('redirect')}
                  />
                </div>
                <div className='col-md-12 mt-4'>
                  <ViewAllSelector
                    onValueChange={(e) =>
                      handleTabData(e, activeTabContent, 'viewAll', 'outerData')
                    }
                    value={viewAll.linkId}
                    onViewAllStatusChange={(e) => {
                      handleTabData(e, activeTabContent, 'viewAllStatus', 'outerData');
                    }}
                    isActive={viewAll.isActive}
                    isRequired={viewAll.isActive ? true : false}
                    error={
                      !isSwapEnabled &&
                      viewAll.linkId === '' &&
                      error?.config?.viewAll === 'required'
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showColorPicker && (
        <ColorPicker
          backgroundColor={outerData.backgroundColor}
          onColorChange={(color) => handleTabData(color, null, 'backgroundColor', 'outerData')}
          showColorPicker={showColorPicker}
          setShowColorPicker={setShowColorPicker}
        />
      )}
    </>
  );
};

export default LargeImageCarouselWithBackground;
